<template>
  <el-card shadow="never" class="contribute-card echarts-box">
    <h4>用户贡献对比</h4>
    <div v-if="userContribute" id="contribute"></div>
    <NoData v-else errTitle="暂无数据" setHeight="400px"></NoData>
  </el-card>
</template>
<script>
import echarts from 'echarts'
import NoData from "@/components/base/no-data"
import { yuanUnit } from '../config'
import { getUserContribute } from "@/api/marketPromotion/activeData"
export default {
  components: {NoData},
  props: {
    baseData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      userContribute: null,
      echartsDom: null
    }
  },
  methods: {
    init () {
      let params = Object.assign({}, this.baseData)
      this.userContribute = null
      this.getUserContribute(params)
    },
    drawLine (data) {
      if (!data) return
      this.echartsDom = null
      this.echartsDom = echarts.init(document.getElementById('contribute'))
      let option = {
        color: ['#3377FF', '#FFAC52', '#ADCD40'],
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          textStyle: {
            color: '#606266'
          },
          formatter: (param) => {
            let html = `<p style="margin:0 0 8px 0"><span style="display:inline-block;width:10px;height:10px;border-radius:5px;border:2px solid ${param.dataIndex === 0 ? '#3377FF' : '#FFAC52'};margin-right:5px"></span>
            <b>${param.name} ${param.value}%</b></p>
            交易人数：${yuanUnit(data[param.dataIndex === 0? 'newUserData' : 'oldUserData'].joinUserNum)}人<br/>
            交易金额：${yuanUnit(data[param.dataIndex === 0? 'newUserData' : 'oldUserData'].transactionAmount)}元<br/>
            交易升数：${yuanUnit(data[param.dataIndex === 0? 'newUserData' : 'oldUserData'].transactionLitre)}升
            `
            return html
          },
          padding: 16,
          extraCssText: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1)'
        },
        legend: {
          data: ['油站新客', '油站老客'],
          right: '4%',
          itemHeight: 2
        },
        series: [
          {
            type:'pie',
            center:['40%','50%'],
            radius : ['50%', '70%'],
            barMaxWidth: '40',
            stack: 'total',
              label: {
                show: false,
                position: 'center'
            },
            labelLine: {
                show: false
            },
            data: [
              {
                value: Math.round(data.newUserData.userPercentage * 10000)/100,
                name:'油站新客'
              },
              {
                value: Math.round(data.oldUserData.userPercentage * 10000)/100,
                name:'油站老客'
              }
            ]
          },
        ]
      }
      this.echartsDom.setOption(option)
    },
    async getUserContribute (params) {
      try {
        const { code, result } = await getUserContribute(params)
        if(code !== 200) return
        this.userContribute = result.newUserData && result.oldUserData ? result : null
        this.$nextTick(() => this.drawLine (this.userContribute))
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import url('../mixin.less');
</style>